// project import
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import LanguageSelector from 'components/LanguageSelector';
import ScrollTop from 'components/ScrollTop';
import AppProvider from 'layout/MainLayout/AppContext/AppProvider';
import { Whitelabelling } from 'layout/Whitelabelling';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'react-i18next';
import Routes from 'routes';
import ThemeCustomization from 'themes';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App: React.FC = (): JSX.Element => {
    const { i18n } = useTranslation();
    return (
        <Whitelabelling>
            <ThemeCustomization>
                <LanguageSelector>
                    <LocalizationProvider dateAdapter={AdapterMoment} locale={i18n.language}>
                        <AppProvider>
                            <ScrollTop>
                                <Routes />
                                <CookieConsent
                                    location="bottom"
                                    buttonText="Ho capito"
                                    cookieName="cookie-consent"
                                    style={{ background: '#2B373B', zIndex: 1400 }}
                                    buttonStyle={{ color: '#4e503b', fontSize: '13px' }}
                                    expires={150} // Numero di giorni prima che il cookie scada
                                    onAccept={() => {
                                        // Puoi aggiungere qui la logica per attivare cookie analitici o di marketing
                                        console.log('Cookie accettati!');
                                    }}
                                    onDecline={() => {
                                        // Puoi aggiungere qui la logica per disabilitare cookie non essenziali
                                        console.log('Cookie rifiutati!');
                                    }}
                                >
                                    I cookie ci aiutano a fornire i nostri servizi. Utilizzando tali servizi, accetti l'utilizzo dei cookie da parte nostra.{' '}
                                    <span style={{ fontSize: '10px' }}>
                                        Maggiori informazioni sulla nostra{' '}
                                        <a href="https://www.beevoip.it/politica-utilizzo-cookies.php">Privacy Policy</a>
                                    </span>
                                </CookieConsent>
                            </ScrollTop>
                        </AppProvider>
                    </LocalizationProvider>
                </LanguageSelector>
            </ThemeCustomization>
        </Whitelabelling>
    );
};

export default App;
